import React from 'react'
import PropTypes from 'prop-types'
import styled from 'react-emotion'
import { heavyFontFamily, mediumMediaQuery } from 'utils/style-helpers'
import Wrapper from 'components/Wrapper'
import { BackgroundContainer, BackgroundImage } from 'components/Background'
import Checklist from './Checklist'

const Container = styled.div`
  color: #616161;
  overflow: hidden;
  padding: 65px 0;
  position: relative;
`

const StyledBackgroundContainer = styled(BackgroundContainer)`
  .gatsby-image-outer-wrapper:after {
    background: rgba(255, 255, 255, 0.85);
    bottom: 0;
    content: "";
    display: block;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }
`

const List = styled.div`
  margin-top: 20px;
  text-align: center;
  width: 100%;

  ${mediumMediaQuery} {
    max-width: 540px;
    text-align: left;
    width: auto;
  }
`

const ContentWrapper = styled(Wrapper)`
  align-items: center;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  max-width: 973px;
  min-height: 225px;
  position: relative;
  z-index: 1;

  &.direction-r {
    flex-direction: row-reverse;

    ${mediumMediaQuery} {
      ${List} {
        margin: 0 0 0 40px;
      }
    }
  }

  ${mediumMediaQuery} {
    flex-wrap: nowrap;
    justify-content: space-between;

    ${List} {
      margin: 0 40px 0 0;
    }
  }
`

const Title = styled.h3`
  color: #4caf50;
  font-size: 32px;
  margin: 0 0 25px 0;
  text-transform: uppercase;
`

const Quote = styled.div`
  margin-top: 20px;
  text-align: center;
  width: 100%;

  ${mediumMediaQuery} {
    margin-top: 0;
    max-width: 345px;
    text-align: left;
    width: auto;
  }
`

const QuoteContent = styled.q`
  color: #2c2c2c;
  display: block;
  font-size: 32px;
  font-style: italic;
  font-weight: 700;
  letter-spacing: 0.18px;
  line-height: 1.2;
  margin: 0 0 16px 0;
  quotes: "“" "”";

  &:before {
    content: open-quote;
  }

  &:after {
    content: close-quote;
  }
`

const Citation = styled.span`
  ${heavyFontFamily()}
  font-size: 18px;
  letter-spacing: 2.8px;
  line-height: 1.2;
  margin: 0;
  text-transform: uppercase;
`

const Benefit = ({ className, background, title, checklist, quote }) => (
  <Container>
    <StyledBackgroundContainer>
      <BackgroundImage sizes={background.childImageSharp.sizes} />
    </StyledBackgroundContainer>
    <ContentWrapper className={className}>
      <List>
        <Title>{title}</Title>
        <Checklist checklist={checklist} />
      </List>
      <Quote>
        <QuoteContent>{quote.content}</QuoteContent>
        <Citation>&mdash; {quote.citation}</Citation>
      </Quote>
    </ContentWrapper>
  </Container>
)

Benefit.propTypes = {
  background: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  checklist: PropTypes.array.isRequired,
  quote: PropTypes.object.isRequired
}

export default Benefit



// WEBPACK FOOTER //
// ./src/components/Benefits/Benefit/index.js